import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { DashboardLayout } from "@/components/DashboardLayout";
import LoginPage from "@/pages/LoginPage";
import LandingPage from "@/pages/LandingPage";
import RegisterCompanyPage from "@/pages/RegisterCompanyPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import InvitePage from "@/pages/InvitePage";
import DashboardPage from "@/pages/DashboardPage";
import AdminTenantsPage from "@/pages/AdminTenantsPage";
import ProfileSettingsPage from "@/pages/ProfileSettingsPage";
import SettingsPage from "@/pages/SettingsPage";
import ModulePage from "@/pages/ModulePage";
import UsersPage from "@/pages/UsersPage";
import BackupPage from "@/pages/BackupPage";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterCompanyPage />} />
            <Route path="/register-company" element={<RegisterCompanyPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/invite" element={<InvitePage />} />
            <Route
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/panel" element={<DashboardPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/settings/profile" element={<ProfileSettingsPage />} />
              <Route path="/abonelikler" element={<ModulePage moduleKey="subscriptions" />} />
              <Route path="/cekler/alinan" element={<ModulePage moduleKey="checks_received" />} />
              <Route path="/cekler/bankaya-verilen" element={<ModulePage moduleKey="checks_bank" />} />
              <Route path="/cekler/cirolanan" element={<ModulePage moduleKey="checks_endorsed" />} />
              <Route path="/cekler/kendi" element={<ModulePage moduleKey="checks_own" />} />
              <Route path="/krediler" element={<ModulePage moduleKey="credits" />} />
              <Route path="/dbs" element={<ModulePage moduleKey="dbs" />} />
              <Route path="/odemeler" element={<ModulePage moduleKey="other_payments" />} />
              <Route path="/tahsilatlar" element={<ModulePage moduleKey="other_collections" />} />
              <Route path="/kasa" element={<ModulePage moduleKey="kasa" />} />
              <Route path="/kredi-kartlari" element={<ModulePage moduleKey="credit_cards" />} />
              <Route path="/pos-hareketleri" element={<ModulePage moduleKey="pos_transactions" />} />
              <Route path="/kullanicilar" element={<UsersPage />} />
              <Route path="/yedekleme" element={<BackupPage />} />
            </Route>
            <Route
              path="/admin/tenants"
              element={
                <ProtectedRoute requireSuperAdmin>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminTenantsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
